import { fokTooltip, gtdTooltip, iocTooltip } from './tooltips';

// Time in force options
export const tifOptions = {
  GTD: {
    value: 'GTD',
    label: 'GTD',
    disabledWithPostOnly: false,
    dropdownLabel: 'Good Till Date',
    tooltip: gtdTooltip(),
  },
  IOC: {
    value: 'IOC',
    label: 'IOC',
    disabledWithPostOnly: true,
    dropdownLabel: 'Immediate or Cancel',
    tooltip: iocTooltip(),
  },
  FOK: {
    value: 'FOK',
    label: 'FOK',
    disabledWithPostOnly: true,
    dropdownLabel: 'Fill or Kill',
    tooltip: fokTooltip(),
  },
} as const;
